import { newAgreementStep1, newAgreementStep2, newAgreementStep3 } from '../router/routes';
import { translate } from '../localization/LanguageContext';

// eslint-disable-next-line import/prefer-default-export
export const steps = [
  { step: translate('step_1'), path: newAgreementStep1 },
  { step: translate('step_2'), path: newAgreementStep2 },
  { step: translate('step_3'), path: newAgreementStep3 },
];
